{
  "addons.addonList": "Toevoegingsoverzicht",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Maak en haal uw API-sleutel op via deze link",
  "addons.ambientWeatherDescription": "Ambient Weerstations (WS-5000, WS-2000, WS2902C,...)",
  "addons.apiKey": "API-sleutel",
  "addons.applicationKey": "Applicatiesleutel",
  "addons.connect": "Verbinden",
  "addons.davisApiSecret": "API Secret",
  "addons.davisApiV2Key": "V2 API-sleutel",
  "addons.davisDescription": "Davis Weerstations (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Haal uw V2 API-sleutels op via deze link",
  "addons.disconnect": "Ontkoppelen",
  "addons.ecowittCreateAndRetrieveKeys": "Maak en haal zowel een API-sleutel als een applicatiesleutel op via deze link",
  "addons.ecowittDescription": "Ecowitt biedt professionele wifi-weerstations, draadloze binnen-buitenthermometers, vochtigheidsmeters, zeer nauwkeurige regenmeters, luchtkwaliteitsmeters en meer.",
  "addons.helpLink": "Hoe verbindt u {provider}",
  "addons.myAcuriteAccountOnHold": "Uw account is in de wacht gezet. Voer uw wachtwoord in om uw account opnieuw te verbinden",
  "addons.myAcuriteDescription": "AcuRite is het nummer 1 weerstationmerk in Noord-Amerika. Als leider op het gebied van tijd-, temperatuur- en weertechnologie biedt AcuRite u gedetailleerde informatie over uw binnen- en buitenomgeving, zodat u uw dag met vertrouwen kunt plannen.",
  "addons.myAcuriteEnterCredentials": "Voer uw My AcuRite-inloggegevens in om uw My AcuRite-account te koppelen aan SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Gebruik uw Netatmo Thermostaat om de temperatuur in huis te veranderen, vanuit bed of vanaf de andere kant van de wereld.",
  "addons.netatmoThermostat": "Netatmo Thermostat",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Uw persoonlijk weerstation inhuis",
  "addons.or": "of",
  "addons.providerAccountDisconnected": "De verbinding met uw weerdienst is verlopen. Maak opnieuw verbinding om de gegevensupdates te hervatten.",
  "addons.reconnect": "Opnieuw verbinden",
  "addons.weatherflowCreateToken": "Maak en haal uw token op via deze link",
  "addons.weatherflowTempestDescription": "Tempest Weather System met ingebouwde Wind- en Regenmeter",
  "addons.wundergroundApiKey": "API-sleutel",
  "addons.wundergroundDescription": "Weather Underground is een wereldwijde gemeenschap van mensen die gegevens van omgevingssensoren zoals weerstations en luchtkwaliteitsmonitors met elkaar verbinden, zodat we de uitgebreide, hyperlokale gegevens kunnen leveren die u nodig hebt om uw passies te stimuleren",
  "addons.wundergroundRetrieveApiKey": "Haal uw API-sleutel op via deze link",
  "addons.wundergroundRetrieveStationId": "Haal uw stations-ID op via deze link",
  "addons.wundergroundStationId": "Station ID",
  "airQuality.adviceActivityGood": "Een ideale dag om buiten actief te zijn",
  "airQuality.adviceActivityHazardous": "Vermijd alle lichamelijke inspanning buiten",
  "airQuality.adviceActivityLabel": "Lichaamsbeweging",
  "airQuality.adviceActivityModerate": "Een goede dag om buiten actief te zijn",
  "airQuality.adviceActivitySensitive": "Overweeg kortere en minder intensieve activiteiten buiten",
  "airQuality.adviceActivityUnhealthy": "Beperk lange of intensieve activiteiten en neem vaker pauze",
  "airQuality.adviceActivityVeryUnhealthy": "Vermijd lange of intensieve activiteiten; overweeg ze naar binnen te verplaatsen",
  "airQuality.adviceGroupsGood": "Geen bijzondere voorzorgsmaatregelen nodig",
  "airQuality.adviceGroupsHazardous": "Blijf binnen en houd de inspanning laag",
  "airQuality.adviceGroupsLabel": "Gevoelige groepen",
  "airQuality.adviceGroupsModerate": "Bijzonder gevoelige personen: kortere en minder intensieve activiteiten",
  "airQuality.adviceGroupsSensitive": "Maak activiteiten buiten korter en minder intensief en neem vaker pauze",
  "airQuality.adviceGroupsUnhealthy": "Vermijd lange of intensieve activiteiten buiten; overweeg ze naar binnen te verplaatsen",
  "airQuality.adviceGroupsVeryUnhealthy": "Vermijd alle lichamelijke inspanning buiten; stel activiteiten uit of doe ze binnen",
  "airQuality.adviceTimingLabel": "Wanneer naar buiten",
  "airQuality.adviceTimingMorning": "Bij voorkeur 's ochtends: dan is het ozongehalte lager",
  "airQuality.airQuality": "Luchtkwaliteit",
  "airQuality.airQualityIndex": "Luchtkwaliteitsindex",
  "airQuality.aqiForecast": "Luchtkwaliteitsvoorspelling",
  "airQuality.co": "Koolmonoxide",
  "airQuality.dailyForecast": "Dagelijkse voorspelling",
  "airQuality.details": "Details",
  "airQuality.dominantPollutant": "Dominante verontreinigende stof",
  "airQuality.expectedPeak": "Verwachte piek",
  "airQuality.good": "Goed",
  "airQuality.goodDescription": "De luchtkwaliteit is redelijk tot goed en luchtverontreiniging vormt weinig of geen risico",
  "airQuality.hazardous": "Gevaarlijk voor de gezondheid",
  "airQuality.hazardousDescription": "Gezondheidswaarschuwing: iedereen kan ernstige(re) gezondheidseffecten ervaren",
  "airQuality.indoorAirQuality": "Luchtkwaliteit binnen",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Gemiddeld",
  "airQuality.moderateDescription": "Luchtkwaliteit is acceptabel; voor sommige verontreinigende stoffen kan er echter een matig gezondheidsrisico zijn voor een zeer klein aantal mensen die bijzonder gevoelig zijn voor luchtverontreiniging.",
  "airQuality.no2": "Stikstofdioxide",
  "airQuality.noForecastForLocation": "Er is geen luchtkwaliteitsverwachting beschikbaar voor deze locatie.",
  "airQuality.now": "Nu",
  "airQuality.o3": "Ozon",
  "airQuality.pm10": "Deeltjes met een diameter van 10 μm of kleiner",
  "airQuality.pm25": "Deeltjes met een diameter van 2,5 μm of minder",
  "airQuality.pollutants": "Verontreinigende stoffen",
  "airQuality.ppb": "ppb",
  "airQuality.recommendations": "Aanbevelingen",
  "airQuality.sensitiveUnhealthy": "Ongezond voor gevoelige mensen",
  "airQuality.sensitiveUnhealthyDescription": "Mensen van gevoelige groepen kunnen gezondheidseffecten ervaren. Het merendeel zal waarschijnlijk niet worden getroffen.",
  "airQuality.so2": "Zwaveldioxide",
  "airQuality.subIndex": "AQI-subindex",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "De index begrijpen",
  "airQuality.unhealthy": "Ongezond",
  "airQuality.unhealthyDescription": "Iedereen kan gezondheidseffecten beginnen te ervaren; Mensen van gevoelige groepen kunnen meer ernstige gevolgen voor de gezondheid ervaren",
  "airQuality.veryUnhealthy": "Zeer ongezond",
  "airQuality.veryUnhealthyDezscription": "Gezondheidswaarschuwingen voor noodsituaties. De kans is groter dat de hele bevolking wordt getroffen.",
  "alerts.addAlert": "Melding toevoegen",
  "alerts.addCondition": "Voorwaarde toevoegen",
  "alerts.alertAdded": "Melding succesvol toegevoegd",
  "alerts.alertAuthorizationNotice": "Meldingen werken alleen als u SmartMixin toestaat om meldingen weer te geven",
  "alerts.alertDeleted": "Melding succesvol verwijderd",
  "alerts.alertEdited": "Melding succesvol gewijzigd",
  "alerts.alertName": "Meldingsnaam",
  "alerts.alertWhen": "Meld mij wanneer:",
  "alerts.aqiGreaterThan": "AQI hoger dan",
  "alerts.aqiGreaterThanThreshold": "AQI hoger dan {value}{unit} drempelwaarde",
  "alerts.aqiLessThan": "AQI lager dan",
  "alerts.aqiLessThanThreshold": "AQI lager dan {value}{unit} drempelwaarde",
  "alerts.atLeastOneCondition": "Voeg tenminste één voorwaarde toe",
  "alerts.co2GreaterThan": "CO2 hoger dan",
  "alerts.co2GreaterThanThreshold": "CO2 hoger dan {value}{unit} drempelwaarde",
  "alerts.co2LessThan": "CO2 lager dan",
  "alerts.co2LessThanThreshold": "CO2 lager dan {value}{unit} drempelwaarde",
  "alerts.conditions": "Voorwaarden",
  "alerts.createAlert": "Melding maken",
  "alerts.dailyPrecipitationGreaterThan": "Dagelijkse neerslag groter dan",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Dagelijkse neerslag boven de drempel van {value}{unit}",
  "alerts.deleteAlert": "Verwijder melding",
  "alerts.editAlert": "Wijzig melding",
  "alerts.editCondition": "Wijzig voorwaarde",
  "alerts.gustSpeedGreaterThan": "Windstoten hoger dan",
  "alerts.gustSpeedGreaterThanThreshold": "Windstoten hoger dan {value}{unit} drempelwaarde",
  "alerts.gustSpeedLessThan": "Windstoten lager dan",
  "alerts.gustSpeedLessThanThreshold": "Windstoten lager dan {value}{unit} drempelwaarde",
  "alerts.heatIndexGreaterThan": "Hitte-index hoger dan",
  "alerts.heatIndexGreaterThanThreshold": "Hitte-index hoger dan {value}{unit} drempelwaarde",
  "alerts.heatIndexLessThan": "Hitte-index lager dan",
  "alerts.heatIndexLessThanThreshold": "Hitte-index lager dan {value}{unit} drempelwaarde",
  "alerts.humidexGreaterThan": "Humidex hoger dan",
  "alerts.humidexGreaterThanThreshold": "Humidex hoger dan {value}{unit} drempelwaarde",
  "alerts.humidexLessThan": "Humidex lager dan",
  "alerts.humidexLessThanThreshold": "Humidex lager dan {value}{unit} drempelwaarde",
  "alerts.humidityGreaterThan": "Luchtvochtigheid hoger dan",
  "alerts.humidityGreaterThanThreshold": "Luchtvochtigheid hoger dan {value}{unit} drempelwaarde",
  "alerts.humidityLessThan": "Luchtvochtigheid lager dan",
  "alerts.humidityLessThanThreshold": "Luchtvochtigheid lager dan {value}{unit} drempelwaarde",
  "alerts.inProgress": "Bezig",
  "alerts.myAlerts": "Mijn meldingen",
  "alerts.noConfiguredAlert": "Er zijn nog geen meldingen, voeg er een toe",
  "alerts.noiseGreaterThan": "Geluid hoger dan",
  "alerts.noiseGreaterThanThreshold": "Geluid hoger dan {value}{unit} drempelwaarde",
  "alerts.noiseLessThan": "Geluid lager dan",
  "alerts.noiseLessThanThreshold": "Geluid lager dan {value}{unit} drempelwaarde",
  "alerts.noteOnConditions": "Houd er rekening mee dat de melding wordt geactiveerd wanneer aan alle onderstaande voorwaarden is voldaan",
  "alerts.noTriggerHistory": "Deze melding is nog niet geactiveerd.",
  "alerts.pm10GreaterThan": "PM 10 hoger dan",
  "alerts.pm10GreaterThanThreshold": "PM 10 hoger dan {value}{unit} drempelwaarde",
  "alerts.pm10LessThan": "PM 10 lager dan",
  "alerts.pm10LessThanThreshold": "PM 10 lager dan {value}{unit} drempelwaarde",
  "alerts.pm1GreaterThan": "PM 1 hoger dan",
  "alerts.pm1GreaterThanThreshold": "PM 1 hoger dan {value}{unit} drempelwaarde",
  "alerts.pm1LessThan": "PM 1 lager dan",
  "alerts.pm1LessThanThreshold": "PM 1 lager dan {value}{unit} drempelwaarde",
  "alerts.pm2p5GreaterThan": "PM 2.5 hoger dan",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 hoger dan {value}{unit} drempelwaarde",
  "alerts.pm2p5LessThan": "PM 2.5 lager dan",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 lager dan {value}{unit} drempelwaarde",
  "alerts.postStormSummary": "Samenvatting na de bui",
  "alerts.postStormSynopsisHelper": "U ontvangt een samenvattingsmelding na elke regenbui.",
  "alerts.postStormSynopsisSoleCondition": "Een samenvatting na de storm kan niet worden gecombineerd met andere voorwaarden.",
  "alerts.precipitationGreaterThan": "Uurlijkse neerslag groter dan",
  "alerts.precipitationGreaterThanThreshold": "Uurlijkse neerslag boven de drempel van {value}{unit}",
  "alerts.pressureGreaterThan": "Luchtdruk hoger dan",
  "alerts.pressureGreaterThanThreshold": "Luchtdruk hoger dan {value}{unit} drempelwaarde",
  "alerts.pressureLessThan": "Luchtdruk lager dan",
  "alerts.pressureLessThanThreshold": "Luchtdruk lager dan {value}{unit} drempelwaarde",
  "alerts.rainRateGreaterThan": "Regenintensiteit groter dan",
  "alerts.rainRateGreaterThanThreshold": "Regenintensiteit boven de drempel van {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Zonnestraling hoger dan",
  "alerts.solarRadiationGreaterThanThreshold": "Zonnestraling hoger dan {value}{unit} drempelwaarde",
  "alerts.solarRadiationLessThan": "Zonnestraling lager dan",
  "alerts.solarRadiationLessThanThreshold": "Zonnestraling lager dan {value}{unit} drempelwaarde",
  "alerts.stormChartUnavailable": "De regengeschiedenis voor deze bui is niet beschikbaar.",
  "alerts.stormDetail": "Samenvatting van de bui",
  "alerts.stormDuration": "Duur",
  "alerts.stormEnd": "Einde",
  "alerts.stormPeakRate": "Maximale regenintensiteit",
  "alerts.stormStart": "Begin",
  "alerts.stormTotal": "Totale neerslag",
  "alerts.temperatureGreaterThan": "Temperatuur hoger dan",
  "alerts.temperatureGreaterThanThreshold": "Temperatuur hoger dan {value}{unit} drempelwaarde",
  "alerts.temperatureLessThan": "Temperatuur lager dan",
  "alerts.temperatureLessThanThreshold": "Temperatuur lager dan {value}{unit} drempelwaarde",
  "alerts.thswGreaterThan": "THSW hoger dan",
  "alerts.thswGreaterThanThreshold": "THSW hoger dan {value}{unit} drempelwaarde",
  "alerts.thswLessThan": "THSW lager dan",
  "alerts.thswLessThanThreshold": "THSW lager dan {value}{unit} drempelwaarde",
  "alerts.thwGreaterThan": "THW hoger dan",
  "alerts.thwGreaterThanThreshold": "THW hoger dan {value}{unit} drempelwaarde",
  "alerts.thwLessThan": "THW lager dan",
  "alerts.thwLessThanThreshold": "THW lager dan {value}{unit} drempelwaarde",
  "alerts.triggerHistory": "Meldingsgeschiedenis",
  "alerts.uvGreaterThan": "UV index hoger dan",
  "alerts.uvGreaterThanThreshold": "UV index hoger dan {value}{unit} drempelwaarde",
  "alerts.uvLessThan": "UV index lager dan",
  "alerts.uvLessThanThreshold": "UV index lager dan {value}{unit} drempelwaarde",
  "alerts.visibilityGreaterThanThreshold": "Zicht meer dan {value}{unit} drempelwaarde",
  "alerts.visibilityLessThanThreshold": "Zicht minder dan {value}{unit} drempelwaarde",
  "alerts.visiblityGreaterThan": "Zicht meer dan",
  "alerts.visiblityLessThan": "Zicht minder dan",
  "alerts.whichMeasure": "Voor welke meting wilt u een melding ontvangen?",
  "alerts.whichModule": "Op welke module zou u willen worden gewaarschuwd?",
  "alerts.windChillGreaterThan": "Gevoelstemperatuur hoger dan",
  "alerts.windChillGreaterThanThreshold": "Gevoelstemperatuur hoger dan {value}{unit} drempelwaarde",
  "alerts.windChillLessThan": "Gevoelstemperatuur lager dan",
  "alerts.windChillLessThanThreshold": "Gevoelstemperatuur lager dan {value}{unit} drempelwaarde",
  "alerts.windSpeedGreaterThan": "Windkracht hoger dan",
  "alerts.windSpeedGreaterThanThreshold": "Windkracht hoger dan {value}{unit} drempelwaarde",
  "alerts.windSpeedLessThan": "Windkracht lager dan",
  "alerts.windSpeedLessThanThreshold": "Windkracht lager dan {value}{unit} drempelwaarde",
  "astral.aboveHorizonAllDay": "De hele dag boven de horizon",
  "astral.aboveTheHorizon": "boven de horizon",
  "astral.apparentSize": "Schijnbare diameter",
  "astral.astronomicalDawn": "Astronomische dageraad",
  "astral.astronomicalDusk": "Astronomische schemering",
  "astral.astronomicalSunPhase": "Astronomisch {sunPhase}",
  "astral.belowHorizonAllDay": "De hele dag onder de horizon",
  "astral.belowHorizonSince": "Onder de horizon sinds {time}",
  "astral.brightAllNight": "De hele nacht licht — nooit volledig donker",
  "astral.brightestMoment": "Helderste moment",
  "astral.civilDawn": "Burgerlijke dageraad",
  "astral.civilDusk": "Burgerlijke schemering",
  "astral.civilSunPhase": "Civiel {sunPhase}",
  "astral.darkSkyWindow": "Donkere hemel {from} → {to} · {duration} zonder maan",
  "astral.dawn": "Ochtendgloren",
  "astral.dayLength": "Daglengte",
  "astral.daylightThroughTheYear": "Daglengte door het jaar heen",
  "astral.dayOfCycle": "dag {day} van {total}",
  "astral.doesNotOccurToday": "Vindt vandaag niet plaats",
  "astral.dusk": "Schemering",
  "astral.earliestSunrise": "Vroegste zonsopkomst",
  "astral.earliestSunset": "Vroegste zonsondergang",
  "astral.equinox": "Equinox",
  "astral.equinoxIn": "Equinox over {days, plural, one {# dag} other {# dagen}}",
  "astral.evening": "Avond",
  "astral.exactPhaseAt": "Precies om {time}",
  "astral.firstQuarter": "Eerste kwartier",
  "astral.firstSunriseIn": "Eerste zonsopkomst over {days, plural, one {# dag} other {# dagen}}",
  "astral.firstSunsetIn": "Eerste zonsondergang over {days, plural, one {# dag} other {# dagen}}",
  "astral.fullMoon": "Volle maan",
  "astral.goldenHourBegins": "Begin gouden uur",
  "astral.goldenHourEnds": "Einde gouden uur",
  "astral.highestPoint": "Hoogste punt",
  "astral.inDays": "over {days, plural, one {# dag} other {# dagen}}",
  "astral.lastQuarter": "Laatste kwartier",
  "astral.latestSunrise": "Laatste zonsopkomst",
  "astral.latestSunset": "Laatste zonsondergang",
  "astral.longestDay": "Langste dag",
  "astral.lowestPoint": "Laagste punt",
  "astral.midday": "Middag",
  "astral.midnightSun": "Middernachtzon",
  "astral.midnightSunPeriod": "Middernachtzon",
  "astral.moon": "Maan",
  "astral.moonAltitude": "Hoogte",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Afstand",
  "astral.moonPhases": "Maanfasen",
  "astral.moonrise": "Maansopkomst",
  "astral.moonset": "Maansondergang",
  "astral.morning": "Ochtend",
  "astral.nauticalDawn": "Nautische dageraad",
  "astral.nauticalDusk": "Nautische schemering",
  "astral.nauticalSunPhase": "Nautisch {sunPhase}",
  "astral.newMoon": "Nieuwe maan",
  "astral.nextDay": "+1 dag",
  "astral.nextRise": "volgende opkomst om {time}",
  "astral.noon": "Middag",
  "astral.noSunriseToday": "Vandaag geen zonsopkomst",
  "astral.nowAtBearing": "nu {altitude} · azimut {direction}",
  "astral.ofDaylightLeft": "daglicht over",
  "astral.overTheNextThreeWeeks": "in de komende 3 weken",
  "astral.percentLit": "{percent} verlicht",
  "astral.polarNight": "Poolnacht",
  "astral.polarNightPeriod": "Poolnacht",
  "astral.remainingDaylight": "Resterend daglicht",
  "astral.rightNow": "Nu",
  "astral.shortestDay": "Kortste dag",
  "astral.solarNoon": "Ware middag",
  "astral.solstice": "Zonnewende",
  "astral.sunBelowHorizon": "Zon {degrees}° onder de horizon",
  "astral.sunEvents": "Zonnegebeurtenissen",
  "astral.sunNeverSets": "De zon gaat niet onder",
  "astral.sunrise": "Zonsopkomst",
  "astral.sunriseAndSunset": "Zonsopkomst en -ondergang",
  "astral.sunriseAt": "Zonsopgang om {time}",
  "astral.sunset": "Zonsondergang",
  "astral.sunsetAt": "Zonsondergang om {time}",
  "astral.thisYearAtNorth": "Dit jaar op {degrees}° NB",
  "astral.thisYearAtSouth": "Dit jaar op {degrees}° ZB",
  "astral.tonight": "Vannacht",
  "astral.totalDaylight": "Totaal daglicht",
  "astral.upFor": "{duration} boven de horizon",
  "astral.usableLight": "Bruikbaar licht",
  "astral.vsAverage": "{percent} t.o.v. gemiddelde",
  "astral.vsYesterday": "t.o.v. gisteren",
  "astral.waningCrescent": "Afnemende maansikkel",
  "astral.waningGibbous": "Afnemende maan",
  "astral.waxingCrescent": "Wassende maansikkel",
  "astral.waxingGibbous": "Wassende maan",
  "auth.alreadyHaveAccount": "Heeft u al een account?",
  "auth.authContainerTagline": "Uw persoonlijke weerdashboard. Verbind uw stations en krijg realtime gegevens binnen handbereik.",
  "auth.backToLogin": "Terug naar inloggen",
  "auth.catchPhrase": "Het Weather Intelligence-platform",
  "auth.checkYourEmail": "Controleer uw e-mail",
  "auth.continueWithApple": "Doorgaan met Apple",
  "auth.continueWithFacebook": "Doorgaan met Facebook",
  "auth.continueWithGoogle": "Doorgaan met Google",
  "auth.email": "Email adres",
  "auth.emailRequiredLoginFacebook": "E-mailtoestemming is vereist.",
  "auth.emailVerification": "Email verificatie",
  "auth.emailVerificationFailure": "Er is een probleem opgetreden met uw e-mailverificatie.",
  "auth.emailVerificationSuccess": "Uw e-mailadres is succesvol geverifieerd.",
  "auth.firstName": "Voornaam",
  "auth.forgotPassword": "Wachtwoord vergeten?",
  "auth.forgotPasswordSubtitle": "Voer uw e-mailadres in en wij sturen u een link om uw wachtwoord te resetten.",
  "auth.lastName": "Achternaam",
  "auth.login": "Inloggen",
  "auth.loginSubtitle": "Welkom terug! Vul alstublieft uw gegevens in.",
  "auth.loginToSmartMixinDescription": "Voer uw SmartMixin-inloggegevens in om toegang te krijgen tot uw account.",
  "auth.logout": "Uitloggen",
  "auth.logoutConfirmation": "Weet u zeker dat u wilt uitloggen?",
  "auth.noAccountYet": "Heeft u nog geen account?",
  "auth.or": "of",
  "auth.password": "Wachtwoord",
  "auth.passwordAgain": "Wachtwoord nogmaals",
  "auth.passwordReset": "Wachtwoord resetten",
  "auth.passwordResetSuccess": "Uw wachtwoord is succesvol aangepast.",
  "auth.register": "Account aanmaken",
  "auth.registerDescription": "Maak een gratis SmartMixin-account aan om uw weerstations te koppelen, weerdata te volgen en toegang te krijgen tot krachtige analysetools.",
  "auth.registerSubtitle": "Maak uw account aan om te beginnen.",
  "auth.registerSuccess": "Registratie geslaagd! Er is een verificatielink gestuurd naar {emailAddress} met verdere instructies.",
  "auth.restorePassword": "Wachtwoord herstellen",
  "auth.restorePasswordSuccess": "Een link voor het opnieuw instellen van uw wachtwoord met verdere instructies is gestuurd naar {emailAddress}.",
  "auth.sendReset": "Verstuur de herstelinstructies",
  "auth.signInWithApple": "",
  "auth.socialAccount": "of gebruik het account",
  "auth.welcome": "Welkom bij SmartMixin",
  "auth.welcomeBack": "Welkom terug!",
  "calendar.april": "April",
  "calendar.august": "Augustus",
  "calendar.dateFormat": "Datumnotatie",
  "calendar.day": "Dag",
  "calendar.december": "December",
  "calendar.end": "Einde",
  "calendar.february": "Februari",
  "calendar.hours": "Uur",
  "calendar.hoursShort": "uren",
  "calendar.january": "Januari",
  "calendar.july": "Juli",
  "calendar.june": "Juni",
  "calendar.last24Hours": "Laatste 24 uur",
  "calendar.last30Days": "Laatste 30 dagen",
  "calendar.last7Days": "Laatste 7 dagen",
  "calendar.march": "Maart",
  "calendar.max": "Maximum",
  "calendar.may": "Mei",
  "calendar.month": "Maand",
  "calendar.months": "maanden",
  "calendar.november": "November",
  "calendar.october": "Oktober",
  "calendar.oneDay": "1-daags",
  "calendar.oneHour": "1-uurs",
  "calendar.oneMonth": "1-maands",
  "calendar.oneWeek": "1-weeks",
  "calendar.previous24Hours": "Voorgaande 24 uur",
  "calendar.previous30Days": "Voorgaande 30 dagen",
  "calendar.previous7Days": "Voorgaande 7 dagen",
  "calendar.previousDay": "Vorige dag",
  "calendar.previousMonth": "Vorige maand",
  "calendar.previousWeek": "Vorige week",
  "calendar.previousYear": "Vorig jaar",
  "calendar.sameDayLastYear": "Zelfde dag vorig jaar",
  "calendar.sameMonthLastYear": "Zelfde maand vorig jaar",
  "calendar.selectADate": "Selecteer een datum",
  "calendar.selectAggregation": "Selecteer weergegeven waarde",
  "calendar.selectAMonth": "Selecteer een maand",
  "calendar.selectAYear": "Selecteer een jaar",
  "calendar.selectGranularity": "Selecteer een schaalweergave",
  "calendar.selectTimescale": "Selecteer een tijdschaal",
  "calendar.september": "September",
  "calendar.sixHours": "6-uurs",
  "calendar.start": "Begin",
  "calendar.thirtyMinutes": "30-minuten",
  "calendar.threeHours": "3-uurs",
  "calendar.use24HourFormat": "Gebruik 24-uursnotatie",
  "calendar.week": "Week",
  "calendar.year": "Jaar",
  "calendar.yesterday": "Gisteren",
  "common.accountDeleted": "Uw account is succesvol verwijderd.",
  "common.accountOnHold": "Uw accountverbinding is verlopen. Maak opnieuw verbinding om de gegevensupdates te hervatten.",
  "common.add": "Voeg toe",
  "common.addAStation": "Voeg een station toe",
  "common.addToFavorites": "Toevoegen aan favorieten",
  "common.addYourOwnStation": "Voeg uw eigen station toe",
  "common.afternoon": "Middag",
  "common.alreadyPremium": "U heeft al een premium account!",
  "common.alsoAvailableOn": "Ook beschikbaar op:",
  "common.altitude": "Hoogte",
  "common.analysis": "Analyse",
  "common.aroundMe": "Om mij heen",
  "common.articleCount": "{count, plural, one {# artikel} other {# artikelen}}",
  "common.articleNotFound": "Artikel niet gevonden",
  "common.articleNotFoundDescription": "Het artikel dat u zoekt bestaat niet.",
  "common.average": "Gemiddeld",
  "common.averageOverThePeriod": "Gemiddelde over de periode",
  "common.away": "Weg",
  "common.back": "Terug",
  "common.backToHelpCenter": "Terug naar helpcentrum",
  "common.backToHome": "Terug naar Home",
  "common.bad": "Slecht",
  "common.batteryLevel": "Batterijniveau",
  "common.bestValue": "Beste Waarde",
  "common.billingDetailsAndroid": "Voor een gratis proefaanbieding worden er geen kosten in rekening gebracht als u 24 uur voor het verstrijken van de gratis introductieperiode annuleert. Wanneer de proefperiode voorbij is, kunt u het SmartMixin-abonnement op elk moment annuleren via uw Google Play-accountinstellingen, anders wordt het automatisch verlengd. Dit moet 24 uur voor het einde van de abonnementsperiode worden gedaan om te voorkomen dat er opnieuw kosten in rekening worden gebracht die in de bovenstaande knop worden weergegeven. Abonnementsbetalingen worden in rekening gebracht op uw Google Play-account bij bevestiging van uw aankoop en bij aanvang van elke verlengingstermijn.",
  "common.billingDetailsIos": "Voor een gratis proefaanbieding worden er geen kosten in rekening gebracht als u 24 uur voor het verstrijken van de gratis introductieperiode annuleert. Wanneer de proefperiode voorbij is, kunt u het SmartMixin-abonnement op elk moment annuleren via uw App Store-accountinstellingen, anders wordt het automatisch verlengd. Dit moet 24 uur voor het einde van de abonnementsperiode worden gedaan om te voorkomen dat er opnieuw kosten in rekening worden gebracht die in de bovenstaande knop worden weergegeven. Abonnementsbetalingen worden in rekening gebracht op uw App Store-account bij bevestiging van uw aankoop en bij aanvang van elke verlengingstermijn.",
  "common.boilerOn": "Boiler aan",
  "common.browseByCategory": "Bladeren op categorie",
  "common.calendarView": "Kalenderweergave",
  "common.cancel": "Annuleren",
  "common.cannotBeEmpty": "Dit veld kan niet leeg zijn.",
  "common.cardDetails": "Kaartdetails",
  "common.categoryNotFound": "Categorie niet gevonden",
  "common.categoryNotFoundDescription": "Deze categorie bestaat niet of bevat geen artikelen.",
  "common.charts": "Grafieken",
  "common.chartView": "Grafiekweergave",
  "common.clearRecentLocations": "Alles wissen",
  "common.close": "Sluiten",
  "common.comparison": "Vergelijk",
  "common.contactMe": "Neem contact met mij op",
  "common.currentDay": "Vandaag",
  "common.currentLocation": "Huidige locatie",
  "common.currentObservations": "Huidige waarnemingen",
  "common.currentRainEvent": "Huidige regenactiviteit",
  "common.currentRate": "Huidige meting",
  "common.currentWeatherConditions": "Huidige omstandigheden",
  "common.customizeComparisonMetrics": "Meetwaarden aanpassen",
  "common.customizeComparisonMetricsDescription": "Sleep items om uw vergelijkingswaarden opnieuw in te delen. Tik op het oogpictogram om meetwaarden weer te geven of te verbergen.",
  "common.customizeDashboard": "Aanpassen",
  "common.customizeDashboardDescription": "Sleep items om uw dashboard te herordenen. Tik op het oogpictogram om secties te tonen of te verbergen.",
  "common.customizedStationName": "Aangepaste stationsnaam",
  "common.dailyForecast": "Dagelijkse voorspelling",
  "common.dashboard": "Dashboard",
  "common.default": "Standaard",
  "common.defaultForecastModelChip": "Standaard · {name}",
  "common.delete": "Verwijderen",
  "common.deleteAccount": "Verwijder uw account",
  "common.deleteAccountConfirmation": "Weet u zeker dat u het account wilt verwijderen? Deze actie is onherstelbaar.",
  "common.deleteAccountDescription": "Met deze actie worden uw account en al uw gegevens verwijderd. Er is geen weg meer terug.",
  "common.details": "Details",
  "common.durationHours": "{hours} u",
  "common.durationHoursMinutes": "{hours} u {minutes} min",
  "common.durationMinutes": "{minutes} min",
  "common.edit": "Wijzigen",
  "common.editor": "Bewerker",
  "common.endTime": "Tijdseinde",
  "common.evening": "Avond",
  "common.exitFullscreen": "Volledig scherm verlaten",
  "common.exploreWeatherMap": "Weerkaart Verkennen",
  "common.favoriteLocations": "Favorieten",
  "common.favoriteLocationsEmpty": "U kunt maximaal 5 favoriete locaties toevoegen.",
  "common.favoriteStations": "Favoriete stations",
  "common.feedbackHelpsImprove": "Uw input helpt ons onze helpartikelen te verbeteren.",
  "common.feedbackReasonNotAnswer": "Het beantwoordt mijn vraag niet",
  "common.feedbackReasonOutdated": "De informatie is verouderd",
  "common.feedbackReasonUnclear": "De instructies zijn onduidelijk",
  "common.feedbackWhatWentWrong": "Wat was het probleem?",
  "common.filterStationDescription": "Verberg stations met onbetrouwbare metingen",
  "common.filterStations": "Filter stations",
  "common.filterStationSourceDescription": "Selecteer stationsaanbieders die u op de kaart wilt weergeven",
  "common.findStationsNearYou": "Vind stations bij u in de buurt",
  "common.firmwareVersion": "Firmwareversie",
  "common.forecast": "Voorspelling",
  "common.forecastComparisonDescription": "Vergelijk eenvoudig de uitvoer van prognosemodellen uit verschillende bronnen",
  "common.forecastModelComparison": "Vergelijking van prognosemodellen",
  "common.forecastModelCoverage": "Dekking",
  "common.forecastModelDescription": "Beschrijving",
  "common.forecastModelDescription_AROME": "Het convectie-oplossende model met hoge resolutie van Météo France boven West-Europa met een resolutie van 1,3 km. Het beste in zijn klasse voor korte-termijnvoorspellingen in Frankrijk; elke drie uur ververst.",
  "common.forecastModelDescription_ARPEGE_EU": "Het Europese nest van het ARPEGE-model van Météo France met een resolutie van 10 km. Voorspellingen op middellange termijn over Europa, viermaal per dag ververst.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Het wereldwijde numerieke weermodel van Météo France met een resolutie van 25 km, dat tot ongeveer 4 dagen loopt. Viermaal per dag ververst.",
  "common.forecastModelDescription_DMI_DINI": "HARMONIE DINI van DMI: een model dat convectie toelaat boven Noordwest-Europa — Denemarken, de Benelux, Ierland, het Verenigd Koninkrijk en Scandinavië — met een resolutie van 2 km dat tot 60 uur loopt, achtmaal per dag ververst. Bevat gewijzigde open data van DMI (CC BY 4.0).",
  "common.forecastModelDescription_EC_GDPS": "Het Globale Deterministische Voorspellingssysteem van Environment Canada: een wereldwijd model op middellange termijn met een resolutie van 15 km dat tot 10 dagen loopt, tweemaal per dag bijgewerkt.",
  "common.forecastModelDescription_EC_HRDPS": "Het Hoge-Resolutie Deterministische Voorspellingssysteem van Environment Canada: een model dat convectie toelaat boven Canada en het noorden van de Verenigde Staten met een resolutie van 2,5 km dat tot 48 uur loopt, viermaal per dag ververst.",
  "common.forecastModelDescription_EC_RDPS": "Het Regionale Deterministische Voorspellingssysteem van Environment Canada: een model op middellange termijn boven Noord-Amerika met een resolutie van 10 km, viermaal per dag ververst.",
  "common.forecastModelDescription_ECMWF_HRES": "Het toonaangevende hogeresolutiemodel (IFS) van het Europees Centrum voor Weersverwachtingen op Middellange Termijn, algemeen beschouwd als het beste mondiale verwachtingssysteem ter wereld. Dekt de hele planeet met een resolutie van 25 km tot 15 dagen vooruit, viermaal daags bijgewerkt. Bevat gewijzigde open data van ECMWF (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "Het vlaggenschipmodel op middellange termijn van NOAA. Bedekt de hele planeet met een resolutie van 25 km tot 16 dagen, viermaal per dag bijgewerkt.",
  "common.forecastModelDescription_HRRR_CONUS": "De High-Resolution Rapid Refresh van NOAA: een convectie-oplossend model boven de continentale Verenigde Staten met een resolutie van 3 km, elk uur ververst. Het meest geschikt voor zeer korte termijn voorspellingen van onweersbuien en zwaar weer.",
  "common.forecastModelDescription_ICON": "Het mondiale ICON-model van DWD met een resolutie van 13 km dat de hele planeet tot 7,5 dagen bestrijkt, vier keer per dag bijgewerkt. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "ICON-2I van ItaliaMeteo, samen met ARPAE beheerd: een model dat convectie toelaat boven Italië met een resolutie van 2,2 km dat tot 72 uur loopt, tweemaal per dag ververst. Bevat open data van ItaliaMeteo (CC BY 4.0).",
  "common.forecastModelDescription_ICON_CH1": "De ICON-CH1-EPS-controlerun van MeteoSwiss: een model dat convectie toelaat boven de Alpen met een resolutie van 1 km dat tot 33 uur loopt, elke drie uur ververst.",
  "common.forecastModelDescription_ICON_CH2": "De ICON-CH2-EPS-controlerun van MeteoSwiss: een model dat convectie toelaat boven de Alpen — Zwitserland en de omliggende Alpenregio — met een resolutie van 2,1 km dat tot 120 uur loopt, viermaal per dag ververst.",
  "common.forecastModelDescription_ICON_DE": "Het convectie-oplossende model met hoge resolutie van DWD boven Duitsland en omliggende landen met een resolutie van 2,2 km. Korte-termijnvoorspellingen tweemaal per dag ververst. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "Het Europese nest van het ICON-model van DWD met een resolutie van 7 km dat Europa en de Noord-Atlantische Oceaan bestrijkt. Voorspellingen op middellange termijn viermaal per dag ververst. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "De open weersvoorspellingsservice van het Noors Meteorologisch Instituut, die hoogwaardige Noordse modellen combineert met ECMWF-gegevens om wereldwijde voorspellingen tot 10 dagen vooruit te bieden.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "AROME-nest boven de Franse Antillen (Guadeloupe, Martinique) met een resolutie van 2,5 km. Korte-termijnvoorspellingen viermaal per dag ververst.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "AROME-nest boven Frans-Guyana met een resolutie van 2,5 km. Korte-termijnvoorspellingen viermaal per dag ververst.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "AROME-nest boven Nieuw-Caledonië met een resolutie van 2,5 km. Korte-termijnvoorspellingen viermaal per dag ververst.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "AROME-nest boven Frans-Polynesië met een resolutie van 2,5 km. Korte-termijnvoorspellingen viermaal per dag ververst.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "AROME-nest boven Réunion en Mayotte met een resolutie van 2,5 km. Korte-termijnvoorspellingen viermaal per dag ververst.",
  "common.forecastModelDescription_NAM_CONUS": "Het North American Mesoscale-modelnest van NOAA boven de continentale Verenigde Staten met een resolutie van 5 km. Korte-termijnvoorspellingen viermaal per dag ververst.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "Het North American Mesoscale-model van NOAA dat heel Noord-Amerika bedekt met een resolutie van 32 km. Viermaal per dag bijgewerkt.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "De vlaggenschipvoorspelling van SmartMixin. Voor elk uur op uw locatie kiezen we het beste beschikbare model — meestal een regionaal model met hoge resolutie waar er een bestaat (AROME in Frankrijk, ICON-D2 in Duitsland, HRRR in de Verenigde Staten, ARPEGE Europe over het hele continent…) en elders teruggrijpen we op een wereldwijd model — vervolgens vullen we eventuele hiaten uit naburige bronnen. Het resultaat is één naadloze voorspelling die overal ter wereld tot 14 dagen bestrijkt, automatisch ververst telkens wanneer een van de onderliggende modellen wordt bijgewerkt.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Weatherflows eigen wereldwijde voorspelling die meerdere numerieke weermodellen combineert met observaties van zijn Tempest-weerstationnetwerk. 10-daagse wereldwijde horizon.",
  "common.forecastModelDetailTitle": "Voorspellingsmodel",
  "common.forecastModelScopeGlobal": "Wereldwijd",
  "common.forecastModelScopeGlobalDescription": "Dit model bestrijkt de hele planeet.",
  "common.forecastModelScopeRegional": "Regionaal",
  "common.forecastModelScopeRegionalDescription": "Dit model bestrijkt slechts een specifieke regio.",
  "common.forecastModelSpecifications": "Specificaties",
  "common.forecastSources": "Bronnen van voorspelling",
  "common.freeAccount": "Gratis account",
  "common.freeSubscription": "Gratis premium abonnement",
  "common.freeTrialForPeriod": "Gratis proefabonnement voor {period} dagen",
  "common.frequency": "Frequentie",
  "common.full": "Volledig",
  "common.fullscreen": "Volledig scherm",
  "common.getStartedFree": "Gratis Beginnen",
  "common.getUnlimitedAccess": "Onbeperkte toegang tot:",
  "common.good": "Goed",
  "common.hail": "Hagel",
  "common.help": "Help",
  "common.helpCategoryAccount": "Account",
  "common.helpCategoryBilling": "Facturering",
  "common.helpCategoryGettingStarted": "Aan de slag",
  "common.helpCategoryProviders": "Providers",
  "common.helpCategoryStations": "Stations",
  "common.helpCategoryTroubleshooting": "Probleemoplossing",
  "common.helpCenter": "Helpcentrum",
  "common.helpCenterDescription": "Vind antwoorden op veelgestelde vragen en leer hoe u het meeste uit SmartMixin haalt.",
  "common.hg": "Vorst bescherming",
  "common.hidden": "Verborgen",
  "common.hiddenSensors": "Verborgen sensoren",
  "common.hiddenStations": "Verborgen stations",
  "common.hiddenStationsDescription": "U kunt een station weer zichtbaar maken door ernaast op het oogpictogram te tikken.",
  "common.high": "Hoog",
  "common.home": "Thuis",
  "common.homeConnectService": "Hebt u een weerstation? Koppel uw dienst",
  "common.homeInformation": "Thuis informatie",
  "common.homeIntroduction": "Verbind uw externe accounts om te genieten van SmartMixin-functies.",
  "common.homeName": "Thuis naam",
  "common.homeSubtitle": "Uw weer, alles op één plek",
  "common.horizon": "Horizon",
  "common.horizonValue": "tot zoveel {value} uren",
  "common.hour": "Uur",
  "common.iDontKnowYet": "Geen idee",
  "common.indoor": "Binnenshuis",
  "common.lastRainEvent": "Laatste regenactiviteit",
  "common.lastUpdate": "Laatste update",
  "common.legendHeavy": "Zwaar",
  "common.legendLight": "Licht",
  "common.legendLightningHelp": "De kleur toont de leeftijd van elke blikseminslag in de afgelopen {minutes} minuten — de nieuwste in wit, de oudste in donkerrood.",
  "common.legendNewest": "Nieuwste",
  "common.legendOldest": "Oudste",
  "common.legendStationsHelp": "De kleur van de markering geeft de waarde van de geselecteerde meting weer.",
  "common.lightningDataAttribution": "Bliksemgegevens: Blitzortung.org",
  "common.lightningStrikes": "Blikseminslagen",
  "common.lightningStrikesDescription": "Toon blikseminslagen in realtime op de kaart",
  "common.linkToSection": "Link naar deze sectie",
  "common.loading": "Bezig",
  "common.location": "Locatie",
  "common.locationAddedToFavorites": "Locatie toegevoegd aan favorieten",
  "common.locationNotGranted": "Locatievermogen wordt niet verleend. Geef toegang tot uw locatie in apparaatinstellingen.",
  "common.locationRemovedFromFavorites": "Locatie verwijderd uit favorieten",
  "common.locations": "Locaties",
  "common.low": "Laag",
  "common.manage": "Beheer",
  "common.manageAccount": "Accountbeheer",
  "common.manageMySubscription": "Abonnementsbeheer",
  "common.manageSensors": "Sensoren beheren",
  "common.manageSensorsDescription": "Sleep items om sensoren te herordenen. Tik op het oogpictogram om sensoren te tonen of verbergen. Tik op een naam om deze te hernoemen.",
  "common.manualBoost": "Handmatige versnelling",
  "common.manualSetpointUntil": "Handmatig instelpunt tot",
  "common.mapLayers": "Kaartlagen",
  "common.mapLegend": "Kaartlegenda",
  "common.maxFavoriteLocationsReached": "U kunt slechts maximaal 5 favoriete locaties hebben. Verwijder de ene om er nog een toe te voegen.",
  "common.maximum": "Maximum",
  "common.measureToDisplay": "Weer te geven meetwaarde",
  "common.medium": "Gemiddeld",
  "common.meshSize": "Rastergrootte",
  "common.minimum": "Minimum",
  "common.minRead": "{minutes} min leestijd",
  "common.modifyFavoriteStations": "Favoriete stations wijzigen",
  "common.modifyFavoriteStationsDescription": "U kunt uw favoriete stations opnieuw ordenen door ze te slepen. U kunt ze ook uit de lijst verwijderen.",
  "common.moduleType": "Type module",
  "common.monthTotal": "Maandtotaal",
  "common.more": "Meer",
  "common.moreInformation": "Meer informatie",
  "common.morning": "Ochtend",
  "common.myLocation": "Mijn locatie",
  "common.nearbyWeatherStations": "Nabijgelegen weerstations",
  "common.next": "Volgende",
  "common.nextHours": "Komende uren",
  "common.night": "Nacht",
  "common.no": "Geen",
  "common.noAccountNeeded": "Geen account nodig",
  "common.noDataForThisPeriod": "Geen data voor deze periode",
  "common.noLocationsFound": "Geen locaties gevonden",
  "common.noNetatmoWeatherStationYet": "Er is nog geen NetAtmo account beschikbaar.",
  "common.noOutdoorModule": "Er is geen werkende buitenmodule aanwezig bij dit station.",
  "common.noSearchResults": "Geen artikelen gevonden voor uw zoekopdracht",
  "common.noStationsFound": "Geen stations gevonden",
  "common.noThermostatYet": "Er is nog geen thermostaat aanwezig.",
  "common.notNow": "Niet nu",
  "common.notPurchasedYet": "Dit is nog niet aangekocht.",
  "common.now": "Nu",
  "common.noWeatherStation": "Geen weerstation aanwezig",
  "common.noWeatherStationYet": "Er is geen weerstation aanwezig.",
  "common.numberOfActiveWarnings": "{warning_count} actieve weerswaarschuwingen",
  "common.onThisPage": "Op deze pagina",
  "common.openSettings": "Open instellingen",
  "common.orChooseMonthly": "Of kies maandelijks:",
  "common.outdatedModule": "De data voor deze module is verouderd.",
  "common.outdoor": "Buiten",
  "common.outdoorTemperature": "Buitentemperatuur",
  "common.pageNotFound": "Pagina Niet Gevonden",
  "common.pageNotFoundDescription": "De pagina die u zoekt bestaat niet of is verplaatst.",
  "common.passwordUpdated": "Wachtwoord succesvol gewijzigd.",
  "common.personalWeatherIntelligence": "Uw Persoonlijke Weerintelligentie",
  "common.platformMobileApp": "Mobiele app",
  "common.platformMobileOnly": "Alleen in de mobiele app",
  "common.platformWebApp": "Webapp",
  "common.platformWebOnly": "Alleen in de webapp",
  "common.popularArticles": "Populaire artikelen",
  "common.premiumAccount": "Premium abonnement",
  "common.premiumDescription": "Een premium abonnement ontgrendelt veel extra functies, zoals geavanceerde weeranalyse, kaartvergelijkingen, regionale voorspellingsmodellen en nog veel meer.",
  "common.premiumFeatureAlerts": "Weerwaarschuwingen",
  "common.premiumFeatureAnalysis": "Geavanceerde Weeranalyse",
  "common.premiumFeatureCharts": "Grafiekvergelijkingen",
  "common.premiumFeatureExport": "Gegevensexport",
  "common.premiumFeatureForecast": "Regionale Voorspellingsmodellen",
  "common.premiumFeatureNotification": "Statusbalk Widget",
  "common.premiumFeatureTitle": "Premium Functie",
  "common.premiumFeatureWidgets": "Startscherm widgets",
  "common.pressureSummary": "Drukoverzicht",
  "common.previous": "Vorig",
  "common.previousHours": "Vorige uren",
  "common.profileUpdated": "Profiel succesvol gewijzigd.",
  "common.purchasedNetatmoPro": "U heeft eerder Netatmo Pro aangeschaft ({date}). Dit geeft toegang tot een subset van premiumfuncties. Abonneer u op een van de volgende aanbiedingen als u toegang wilt hebben tot alle premiumfuncties.",
  "common.radarDataAttribution": "Radargegevens: NOAA / EUMETNET OPERA via LibreWXR",
  "common.rain": "Regen",
  "common.rainEvents": "Regenactiviteiten",
  "common.rainfallMeasurement": "Regenmeting",
  "common.rainRadar": "Buienradar",
  "common.rainRadarDescription": "Geef de regenradar-overlay op de kaart weer",
  "common.rainSummary": "Buienoverzicht",
  "common.range": "Bereik",
  "common.recentLocations": "Recentelijk",
  "common.recentLocationsEmpty": "Uw recente geschiedenis is leeg.",
  "common.recentStations": "Recente stations",
  "common.relatedArticles": "Gerelateerde artikelen",
  "common.relay": "Relais",
  "common.removeFromFavorites": "Verwijder uit favorieten",
  "common.renameSensors": "Hernoem sensoren",
  "common.resetZoom": "Reset Zoom",
  "common.restorePurchase": "Herstel aankoop",
  "common.room": "Kamer",
  "common.rooms": "Kamers",
  "common.savingsPercent": "Bespaar {percent}%",
  "common.searchArticles": "Artikelen zoeken...",
  "common.searchForALocation": "Zoek naar een locatie...",
  "common.searchForLocation": "Zoek een locatie",
  "common.searchForWeatherStation": "Zoek een weerstation",
  "common.searchResults": "Zoekresultaten",
  "common.searchResultsEmpty": "Geen resultaten gevonden.",
  "common.searchResultsFound": "{count, plural, one {# resultaat gevonden} other {# resultaten gevonden}}",
  "common.searchStationsDescription": "Voer een stad, adres of plaatsnaam in om weerstations in de buurt te vinden.",
  "common.searchStationsHint": "Gebruik de zoekbalk hierboven om weerstations op elke locatie ter wereld te ontdekken.",
  "common.selectStationForComparison": "Zoek een station om te vergelijken",
  "common.selectWeatherForecastProvider": "Selecteer een weersaanbieder",
  "common.serialNumber": "Serienummer",
  "common.share": "Delen",
  "common.shareOutdoorMeasures": "Deel uw buitenmetingen",
  "common.shareOutdoorMeasuresDescription": "Neem deel aan de SmartMixin-community door uw buitenmetingen zichtbaar te maken voor anderen. Metingen binnenshuis worden nooit gedeeld.",
  "common.shareYourWeather": "Deel de weermetingen",
  "common.signalStrength": "Signaalsterkte",
  "common.skip": "Overslaan",
  "common.smartThermostat": "Smart Thermostaat",
  "common.smartValve": "Smart Valve",
  "common.snow": "Sneeuw",
  "common.start": "Begin",
  "common.startFreeTrial": "Gratis Proefperiode Starten",
  "common.startTime": "Starttijd",
  "common.station": "station",
  "common.stationAddedToFavorites": "Station toegevoegd aan favorieten",
  "common.stationComparison": "Stationsvergelijking",
  "common.stationComparisonDescription": "Vergelijk historische weergegevens met een ander station",
  "common.stationInformation": "Stationsinformatie",
  "common.stationName": "Stationsnaam",
  "common.stationObservationsDescription": "Toon de laatste waarnemingen van weerstations",
  "common.stationRemovedFromFavorites": "Station verwijderd uit favorieten",
  "common.stations": "stations",
  "common.stationsNear": "Stations nabij",
  "common.stationType": "Type station",
  "common.statusOffline": "Offline",
  "common.statusOnline": "Online",
  "common.statusStale": "Verouderd",
  "common.statusSyncing": "Synchroniseren",
  "common.stillNeedHelp": "Nog steeds hulp nodig?",
  "common.stillNeedHelpDescription": "Als dit artikel uw vraag niet heeft beantwoord, help ik u graag persoonlijk verder.",
  "common.subscribeNow": "Nu abonneren - zonder proefperiode",
  "common.sumOverThePeriod": "Totaal over de periode",
  "common.switchToPremium": "Wijzig naar SmartMixin Premium",
  "common.temperatureShort": "Temp.",
  "common.temperatureSummary": "Temperatuursoverzicht",
  "common.thankYouForFeedback": "Bedankt voor uw feedback!",
  "common.thenPrice": "daarna {price}",
  "common.timeSelection": "Tijdselectie",
  "common.timezone": "Tijdzone",
  "common.totalDuration": "Totale duur",
  "common.tryAnotherLocation": "We konden geen weerstations vinden in de buurt van deze locatie. Probeer te zoeken in een ander gebied.",
  "common.unknown": "Onbekend",
  "common.untilChanged": "Tot gewijzigd",
  "common.untilTime": "Tot {time}",
  "common.updateAvailable": "Update beschikbaar",
  "common.updateAvailableOpenAppStore": "Tik om de App Store te openen",
  "common.updateAvailableOpenGooglePlay": "Tik om Google Play te openen",
  "common.updateAvailableVersion": "Update beschikbaar: v{version}",
  "common.upgrade": "Upgraden",
  "common.upgradeRequiredAndroid": "Een upgrade van de applicatie is vereist. Bezoek Google Play om te upgraden.",
  "common.upgradeRequiredIos": "Een upgrade van de applicatie is vereist. Bezoek de App Store om te upgraden.",
  "common.validate": "Bevestigen",
  "common.validEmail": "Een geldig e-mailadres is verplicht.",
  "common.very_low": "Zeer laag",
  "common.viewAsList": "Lijst",
  "common.viewAsPeriods": "Dagdelen",
  "common.visitNetatmoWebsite": "Bezoek de NetAtmo website",
  "common.wasArticleHelpful": "Was dit artikel nuttig?",
  "common.weatherCondition": "Weersgesteldheid",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain is een extra gegevensbron die wordt geleverd via het Tempest Weather System, mogelijk gemaakt door Nearcast Technology. NC Rain-gegevens zijn een schatting van de gemiddelde neerslagaccumulatie rond uw Tempest op buurtniveau",
  "common.weatherForecastModels": "Modellen voor weersvoorspellingen",
  "common.weatherIntelligencePlatform": "Het Weerintelligentie Platform",
  "common.weatherMap": "Weerkaart",
  "common.weatherMapMetaDescription": "SmartMixin biedt interactieve weer- en radarkaarten voor weersomstandigheden wereldwijd.",
  "common.weatherObservations": "Weerobservaties",
  "common.weatherStation": "Weerstation",
  "common.weatherStations": "Weerstations",
  "common.welcome": "Welkom bij SmartMixin!",
  "common.whenBackHome": "Wanneer bent u weer thuis?",
  "common.wifiStrength": "WiFi-signaal",
  "common.wind": "Wind",
  "common.windMeasurement": "Windmeting",
  "common.windSpeed": "Windsnelheid",
  "common.windSummary": "Windoverzicht",
  "common.yearToDate": "Sinds jaarbegin",
  "common.yes": "Ja",
  "common.zoomImage": "Afbeelding vergroten",
  "forecastMaps.addColor": "Kleur toevoegen",
  "forecastMaps.addLayer": "Laag toevoegen",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Terug naar kaarten",
  "forecastMaps.browseMaps": "Kaarten verkennen",
  "forecastMaps.build": "Genereren",
  "forecastMaps.buildCompleted": "Genereren voltooid",
  "forecastMaps.builderMetaDescription": "Stel eigen verwachtingskaarten samen uit de lagen van weermodellen.",
  "forecastMaps.builderTitle": "Kaartenbouwer",
  "forecastMaps.buildFailed": "Het genereren is mislukt. Probeer het opnieuw.",
  "forecastMaps.buildNotPossible": "Deze kaart kan nog niet worden gegenereerd — er zijn geen verwachtingsgegevens beschikbaar.",
  "forecastMaps.buildProgress": "Renderen… {completed}/{total} stappen",
  "forecastMaps.buildStarting": "Genereren wordt gestart…",
  "forecastMaps.byModel": "Per model",
  "forecastMaps.byZone": "Per zone",
  "forecastMaps.colormap": "Kleurenschaal",
  "forecastMaps.colormapCustom": "Aangepaste kleuren",
  "forecastMaps.colormapGroupDomain": "Weer-voorinstellingen",
  "forecastMaps.colormapGroupMatplotlib": "Wetenschappelijke voorinstellingen",
  "forecastMaps.colorScale": "Kleurenschaal",
  "forecastMaps.comingSoon": "Deze weergave komt binnenkort.",
  "forecastMaps.contourLevels": "Contourniveaus",
  "forecastMaps.countryCanada": "Canada",
  "forecastMaps.countryFrance": "Frankrijk",
  "forecastMaps.countryGermany": "Duitsland",
  "forecastMaps.countryItaly": "Italië",
  "forecastMaps.countryScandinavia": "Scandinavië",
  "forecastMaps.countrySpain": "Spanje",
  "forecastMaps.countrySwitzerland": "Zwitserland",
  "forecastMaps.countryUnitedStates": "Verenigde Staten",
  "forecastMaps.customColormapMinColors": "Een aangepaste kleurenschaal heeft minstens twee kleuren nodig",
  "forecastMaps.customExtent": "Aangepast gebied",
  "forecastMaps.deleteMap": "Kaart verwijderen",
  "forecastMaps.deleteMapBody": "'{name}' en de bijbehorende renders worden permanent verwijderd.",
  "forecastMaps.deleteMapTitle": "Deze kaart verwijderen?",
  "forecastMaps.displayName": "Weergavenaam",
  "forecastMaps.downloadMp4": "MP4 downloaden",
  "forecastMaps.downscaling": "Uitdunningsfactor windvanen",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Gebied tekenen",
  "forecastMaps.east": "Oost",
  "forecastMaps.editMap": "Kaart bewerken",
  "forecastMaps.exportBuilding": "Video wordt voorbereid…",
  "forecastMaps.exportError": "Het exporteren van de video is mislukt. Probeer het opnieuw.",
  "forecastMaps.exportMp4": "MP4 exporteren",
  "forecastMaps.exportNotReady": "De video is nog niet klaar. Probeer het later opnieuw.",
  "forecastMaps.extentDrawHint": "Sleep op de kaart om het gebied te tekenen",
  "forecastMaps.extentInvalid": "West moet kleiner zijn dan oost en zuid kleiner dan noord",
  "forecastMaps.extentPanZoomHint": "Verschuif en zoom tot het gebied het kader vult",
  "forecastMaps.flipbookView": "Animatie",
  "forecastMaps.forecastModel": "Voorspellingsmodel",
  "forecastMaps.forkAndEdit": "Dupliceren en bewerken",
  "forecastMaps.height": "Hoogte (inch)",
  "forecastMaps.hourOffset": "+{hour} u",
  "forecastMaps.invalidHexColor": "Ongeldige kleur — gebruik #RRGGBB",
  "forecastMaps.layers": "Lagen",
  "forecastMaps.layerTypeBarbs": "Windvanen",
  "forecastMaps.layerTypeContour": "Contourlijnen",
  "forecastMaps.layerTypeFilledContour": "Gevulde contouren",
  "forecastMaps.layerTypeMagnitude": "Magnitude",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Vectorveld",
  "forecastMaps.leave": "Verlaten",
  "forecastMaps.levelsCount": "Aantal",
  "forecastMaps.levelsInvalid": "Ongeldige contourniveaus",
  "forecastMaps.levelsModeArange": "Vaste stap",
  "forecastMaps.levelsModeExplicit": "Expliciete waarden",
  "forecastMaps.levelsModeLinspace": "Gelijkmatig verdeeld (aantal)",
  "forecastMaps.levelsStep": "Stap",
  "forecastMaps.levelsValues": "Waarden",
  "forecastMaps.levelsValuesHint": "Kommagescheiden, oplopend",
  "forecastMaps.localTimeHint": "Weergegeven in uw lokale tijd",
  "forecastMaps.map": "Kaart",
  "forecastMaps.mapDescription": "Beschrijving",
  "forecastMaps.mapName": "Kaartnaam",
  "forecastMaps.mapNameRequired": "Voer een naam in",
  "forecastMaps.mapSettings": "Kaartinstellingen",
  "forecastMaps.mapView": "Interactieve kaart",
  "forecastMaps.maxLayersReached": "Deze kaart heeft het maximum van {max} lagen bereikt.",
  "forecastMaps.maxValue": "Maximumwaarde",
  "forecastMaps.memoryBudgetExceeded": "De resolutie overschrijdt het renderbudget — verlaag de DPI of de hoogte",
  "forecastMaps.memoryBudgetUsage": "Renderbudget: {percent}%",
  "forecastMaps.metaDescription": "Geanimeerde voorspellingskaarten op basis van weermodellen.",
  "forecastMaps.metric": "Meetwaarde",
  "forecastMaps.metricRequired": "Selecteer een meetwaarde",
  "forecastMaps.metricUnavailable": "Niet beschikbaar voor dit model",
  "forecastMaps.minBelowMax": "Min moet kleiner zijn dan max",
  "forecastMaps.minMaxRequired": "Min- en maxwaarden zijn verplicht voor dit laagtype",
  "forecastMaps.minValue": "Minimumwaarde",
  "forecastMaps.modelNoRun": "Nog geen voltooide run",
  "forecastMaps.moveLayerDown": "Omlaag",
  "forecastMaps.moveLayerUp": "Omhoog",
  "forecastMaps.myMaps": "Mijn kaarten",
  "forecastMaps.nanClipToMin": "Begrenzen op min",
  "forecastMaps.nanMask": "Maskeren",
  "forecastMaps.nanPolicy": "Ontbrekende gegevens",
  "forecastMaps.nanSkip": "Overslaan",
  "forecastMaps.newMap": "Nieuwe kaart",
  "forecastMaps.noCompletedRun": "Deze kaart is nog niet gegenereerd. Kom binnenkort terug.",
  "forecastMaps.noLayers": "Nog geen lagen. Voeg een laag toe om te beginnen.",
  "forecastMaps.noMapsAvailable": "Er zijn nog geen voorspellingskaarten beschikbaar.",
  "forecastMaps.north": "Noord",
  "forecastMaps.opacity": "Dekking",
  "forecastMaps.overlayLegend": "Legenda",
  "forecastMaps.pause": "Pauze",
  "forecastMaps.play": "Afspelen",
  "forecastMaps.pointValueError": "De verwachting voor dit punt kon niet worden geladen.",
  "forecastMaps.pointValueLoading": "Verwachting laden…",
  "forecastMaps.pointValueUnavailable": "Geen gegevens voor dit tijdstip.",
  "forecastMaps.presets": "Voorinstellingen",
  "forecastMaps.preview": "Voorbeeld",
  "forecastMaps.previewEmptyHint": "Configureer minstens één geldige laag om een voorbeeld te renderen.",
  "forecastMaps.previewFailed": "Het voorbeeld is mislukt",
  "forecastMaps.previewHour": "Verwachtingsuur",
  "forecastMaps.previewRendering": "Voorbeeld wordt gerenderd…",
  "forecastMaps.projection": "Projectie",
  "forecastMaps.projectionLambertConformal": "Lambert conform",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografisch",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "Noord-Amerika",
  "forecastMaps.removeColor": "Kleur verwijderen",
  "forecastMaps.removeLayer": "Laag verwijderen",
  "forecastMaps.retry": "Opnieuw proberen",
  "forecastMaps.run": "Run: {run}",
  "forecastMaps.save": "Opslaan",
  "forecastMaps.selectExtentOnMap": "Gebied op de kaart selecteren",
  "forecastMaps.south": "Zuid",
  "forecastMaps.title": "Voorspellingskaarten",
  "forecastMaps.uMetric": "U-component",
  "forecastMaps.unitConversion": "Eenheidsconversie",
  "forecastMaps.unitNone": "Geen",
  "forecastMaps.unsavedChangesBody": "U hebt niet-opgeslagen wijzigingen. Verlaten en verwerpen?",
  "forecastMaps.unsavedChangesTitle": "Niet-opgeslagen wijzigingen",
  "forecastMaps.useCurrentView": "Huidige weergave gebruiken",
  "forecastMaps.useModelDomain": "Uit: het volledige modeldomein wordt gebruikt",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "U- en V-meetwaarden moeten verschillen",
  "forecastMaps.validTime": "Geldig: {time}",
  "forecastMaps.valueBetween": "Moet tussen {min} en {max} liggen",
  "forecastMaps.variable": "Variabele",
  "forecastMaps.viewMap": "Kaart bekijken",
  "forecastMaps.vMetric": "V-component",
  "forecastMaps.west": "West",
  "forecastMaps.windAnimation": "Windanimatie",
  "intro.locationDescription": "Sta locatievoorziening toe voor nauwkeurige weersvoorspellingen die zijn afgestemd op jouw exacte gebied — geen one‑size‑fits‑all voorspellingen meer.",
  "intro.locationTitle": "Voorspellingen op maat voor jou",
  "intro.notificationDescription": "Schakel meldingen in voor tijdige waarschuwingen over weersveranderingen die er voor jou toe doen — regen, sneeuw of ernstige omstandigheden, precies wanneer je het nodig hebt.",
  "intro.notificationsTitle": "Mis nooit een weerverschuiving",
  "intro.readyDescription": "Geniet van nauwkeurige voorspellingen, realtime weersinzichten en stationgegevens van over de hele wereld — alles in één krachtige app.",
  "intro.readyTitle": "Je bent er klaar voor!",
  "intro.welcomeDescription": "Ontvang hyperlokale voorspellingen van toonaangevende meteorologische diensten — plus toegang tot meer dan 40.000 weerstations wereldwijd om echte omstandigheden te zien, heden en verleden.",
  "intro.welcomeTitle": "Jouw weer, opnieuw bedacht",
  "landing.alerts": "Waarschuwingen",
  "landing.alertsDescription": "Creëer uw eigen waarschuwingen en ontvang een melding zodra ze worden geactiveerd.",
  "landing.featureAlertsDescription": "Stel aangepaste waarschuwingen in voor omstandigheden die u belangrijk vindt—temperatuur, wind, neerslag en meer.",
  "landing.featureAlertsTitle": "Slimme waarschuwingen",
  "landing.featureAnalyticsDescription": "Duik in uw gegevens met interactieve grafieken, zij-aan-zij vergelijkingen en trendanalyses die verder gaan dan basismetrieken.",
  "landing.featureAnalyticsTitle": "Krachtige analyses",
  "landing.featureExportDescription": "Download uw gegevens in CSV-formaat voor analyse in Excel, integratie met andere systemen of back-up.",
  "landing.featureExportTitle": "Overal exporteren",
  "landing.featureForecastDescription": "Vergelijk voorspellingen van meer dan 10 weermodellen waaronder GFS, ECMWF, ICON en meer om te zien welke het beste werkt voor uw locatie.",
  "landing.featureForecastTitle": "Voorspellingsvergelijking",
  "landing.featureHistoryDescription": "Toegang tot historische gegevens met uur-, dag- en maandschaal. Exporteer naar CSV voor onderzoek of persoonlijke archieven.",
  "landing.featureHistoryTitle": "Rijke geschiedenis",
  "landing.featureMultiBrandDescription": "Verbind stations van Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow en meer—allemaal in één dashboard.",
  "landing.featureMultiBrandTitle": "Multi-merk ondersteuning",
  "landing.featuresSubtitle": "Ontworpen voor weerenthousiastelingen die meer eisen dan een basis weerstation-app.",
  "landing.featuresTitle": "Alles wat u nodig heeft om weer te analyseren",
  "landing.finalCtaButton": "Gratis account aanmaken",
  "landing.finalCtaSubtitle": "Sluit u aan bij duizenden weerenthousiastelingen die vertrouwen op SmartMixin voor hun weergegevens.",
  "landing.finalCtaTitle": "Klaar om uw weerervaring te verbeteren?",
  "landing.forecastDescription": "Krijg toegang tot enkele van de beste weersvoorspellingsmodellen en vergelijk ze om uw eigen idee te krijgen van wat voor weer het zal zijn.",
  "landing.forecasts": "Voorspellingen",
  "landing.heroCta": "Gratis beginnen",
  "landing.heroDescription": "Combineer meerdere weerstations van elk merk, vergelijk voorspellingsmodellen en analyseer uw gegevens met gedetailleerde grafieken en exports.",
  "landing.heroSecondaryCta": "Functies bekijken",
  "landing.heroTagline": "Alle weergegevens. Eén platform.",
  "landing.heroTitle": "Alle weergegevens. Eén platform.",
  "landing.pricingFeatureAdvancedMetrics": "Geavanceerde metingen",
  "landing.pricingFeatureAlerts": "Aangepaste waarschuwingen",
  "landing.pricingFeatureExport": "Gegevensexport (CSV)",
  "landing.pricingFeatureForecastComparison": "Prognosevergelijking",
  "landing.pricingFeatureForecasts": "Voorspellingsmodellen",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "Alle modellen (10+)",
  "landing.pricingFeatureReports": "Analyses & rapporten",
  "landing.pricingFeatureStationComparison": "Stationsvergelijking",
  "landing.pricingFeatureWidgets": "Startscherm-widgets",
  "landing.pricingFeatureYearOverYear": "Jaarlijkse vergelijking",
  "landing.pricingFree": "Gratis",
  "landing.pricingFreeCta": "Aan de slag",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Meest populair",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Aan de slag",
  "landing.pricingPremiumDescription": "Vanaf 1,99 €/maand — abonneer via web, App Store of Google Play",
  "landing.pricingSubtitle": "Begin gratis, upgrade wanneer u meer nodig hebt.",
  "landing.pricingTitle": "Eenvoudige, transparante prijzen",
  "landing.smartMixinDescription": "SmartMixin is een applicatie die toegang biedt tot uw weerstation en meer dan 40.000 andere stations wereldwijd. Het helpt u weergegevens te bekijken en te begrijpen.",
  "landing.statBrands": "Ondersteunde merken",
  "landing.statForecasts": "Voorspellingsmodellen",
  "landing.statStations": "Verbonden stations",
  "landing.supportedDevices": "Ondersteunde apparaten",
  "landing.supportedDevicesDescription": "Naast de stations van de World Meteorological Organization ondersteunt SmartMixin een groeiend aantal weerstationmerken.",
  "landing.supportedDevicesNote": "Plus meer dan 40.000 openbare stations van de Wereld Meteorologische Organisatie",
  "landing.supportedDevicesSubtitle": "Verbind weerstations van toonaangevende merken en bekijk alle gegevens op één plaats.",
  "landing.supportedDevicesTitle": "Werkt met uw stations",
  "landing.thermostatDescription": "Verbind uw Netatmo-thermostaat om verwarmingspatronen te vergelijken met buitenomstandigheden.",
  "landing.thermostatManufacturers": "Thermostaatfabrikanten worden ook ondersteund om verwarming te correleren met buitenomstandigheden.",
  "landing.thermostatTitle": "Slim huis-integratie",
  "landing.weatherAnalysis": "Weeranalyse",
  "landing.weatherAnalysisDescription": "SmartMixin wordt geleverd met veel datavisualisatie waarmee u weergegevens kunt analyseren.",
  "landing.weatherAssistant": "Uw weerassistent",
  "landing.weatherAssistantDescription": "Of u nu geïnteresseerd bent in huidige, historische of voorspelde weersomstandigheden, SmartMixin biedt talloze inzichten wanneer u ze nodig heeft.",
  "landing.weatherForecastModels": "Weersvoorspellingsmodellen",
  "landing.weatherForecastModelsDescription": "SmartMixin biedt toegang tot de meest nauwkeurige weersvoorspellingsmodellen. U kunt eenvoudig hun prognoses vergelijken en uw eigen idee maken.",
  "landing.weatherMap": "Weerkaart",
  "landing.weatherMapDescription": "Blader door de kaart en visualiseer hoe het weer overal ter wereld is.",
  "network.cancelError": "Verzoek is geannuleerd",
  "network.connectionError": "Server niet beschikbaar",
  "network.networkError": "Netwerk niet beschikbaar",
  "network.serverError": "Er is iets misgegaan...",
  "network.timeoutError": "Verbinding time-out",
  "network.unknownError": "Onbekende fout",
  "providerHints.ambientWeatherApiKey": "Aangemaakt in de instellingen van uw ambientweather.net-account.",
  "providerHints.davisApiSecret": "Wordt slechts één keer getoond bij het aanmaken van de V2 API-sleutel — bewaar het veilig.",
  "providerHints.davisV2ApiKey": "Van de V2 API-sleutelpagina op weatherlink.com.",
  "providerHints.ecowittApi": "Van de API-pagina van uw Ecowitt-account.",
  "providerHints.ecowittApp": "De applicatiesleutel, ook uit uw Ecowitt-account.",
  "providerHints.myAcuriteCredentialsBanner": "Gebruik e-mail en wachtwoord van uw My AcuRite-account — niet uw SmartMixin-login.",
  "providerHints.myAcuriteEmail": "Het e-mailadres van uw My AcuRite-account — niet uw SmartMixin-login.",
  "providerHints.myAcuritePassword": "Het wachtwoord van uw My AcuRite-account.",
  "providerHints.weatherflowToken": "Persoonlijk token van tempestwx.com → instellingen → gegevensautorisaties.",
  "providerHints.wundergroundEditKey": "Een andere sleutel gebruiken",
  "providerHints.wundergroundKey": "Een lange reeks van uw Weather Underground API-sleutelpagina — niet uw wunderground.com-wachtwoord.",
  "providerHints.wundergroundKeyExample": "bijv. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API-sleutel geverifieerd",
  "providerHints.wundergroundKeyVerifying": "Sleutel controleren…",
  "providerHints.wundergroundNoStationsNearby": "Geen stations gevonden in de buurt. Probeer rechtstreeks een stations-ID in te voeren.",
  "providerHints.wundergroundStationId": "Elke Weather Underground stations-ID — uw eigen of een openbaar station bij u in de buurt.",
  "providerHints.wundergroundStationIdExample": "bijv. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Haal uw Ambient Weather API-sleutel op.",
  "providerIntro.davisStep2": "Haal uw Davis V2 API-sleutel en API-secret op.",
  "providerIntro.ecowittStep2": "Haal uw Ecowitt API-sleutel en applicatiesleutel op.",
  "providerIntro.getStarted": "Aan de slag",
  "providerIntro.myAcuriteStep2": "Gebruik e-mail en wachtwoord van uw bestaande My AcuRite-account.",
  "providerIntro.netatmoEnergyStep2": "Log in bij Netatmo wanneer hierom wordt gevraagd — geen API-sleutel nodig.",
  "providerIntro.netatmoWeatherStep2": "Log in bij Netatmo wanneer hierom wordt gevraagd — geen API-sleutel nodig.",
  "providerIntro.signupBanner": "Bijna klaar — maak uw gratis SmartMixin-account aan om {provider} te verbinden.",
  "providerIntro.step1": "Log in op uw SmartMixin-account (NIET uw {provider}-login).",
  "providerIntro.step3EmailPassword": "Voer ze hier in.",
  "providerIntro.step3KeyOrToken": "Plak het hier.",
  "providerIntro.step3OAuth": "Geef SmartMixin toestemming in het pop-upvenster.",
  "providerIntro.step3Wunderground": "Plak uw API-sleutel en kies dan een station in de buurt of voer een willekeurige stations-ID in.",
  "providerIntro.title": "{provider} verbinden",
  "providerIntro.weatherflowStep2": "Haal uw persoonlijke Tempest-token op.",
  "providerIntro.wundergroundBrowsePublic": "Geen station? Bekijk de openbare stations",
  "providerIntro.wundergroundFindNearby": "Stations bij mij in de buurt zoeken",
  "providerIntro.wundergroundOrEnterId": "Of voer een stations-ID in",
  "providerIntro.wundergroundStep2": "Haal uw Weather Underground API-sleutel op. Daarna kunt u elk station verbinden — uw eigen of een openbaar station.",
  "reports.agroMeteorology": "Agrometeorologie",
  "reports.analysis": "Analyse",
  "reports.annualCumulativeRainfallComparison": "Jaarlijkse cumulatieve neerslagvergelijking",
  "reports.annualHeatingDurationComparison": "Vergelijking van de jaarlijkse opwarmingsduur",
  "reports.annualHeatingEfficiency": "Jaarlijks opwarmingsrendement",
  "reports.annualIndoorComparison": "Jaarlijkse vergelijking binnenshuis",
  "reports.annualIndoorReport": "Jaarlijks overzicht binnenshuis",
  "reports.annualOutdoorComparison": "Jaarlijkse vergelijk buitenshuis",
  "reports.annualOutdoorReport": "Jaarlijks overzicht buitenshuis",
  "reports.annualReport": "Jaarlijks overzicht",
  "reports.annualSolarReport": "Jaarlijks overzicht zonneschijn",
  "reports.annualWaterBalance": "Jaarlijkse waterbalans",
  "reports.annualWaterBalanceCarryOver": "Vorig jaar overdragen",
  "reports.annualWaterBalanceDescription": "De waterbalans (vereenvoudigde versie, alleen regen en verdamping worden gebruikt) voor het beheer van de watertoevoer",
  "reports.avgHumidity": "Gemiddelde luchtvochtigheid",
  "reports.avgMaxTemperature": "Gemiddelde T°max",
  "reports.avgMetric": "Gemiddelde {metric}",
  "reports.avgMinTemperature": "Gemiddelde T°min",
  "reports.avgPressure": "Gemiddelde luchtdruk",
  "reports.avgTemperature": "Gemiddelde temperatuur",
  "reports.climateNormalPeriodOfRecord": "Meetperiode ({years} jaar)",
  "reports.climateNormals": "Klimaatnormalen",
  "reports.climateNormalStandardLabel": "Normaalperiode ({period})",
  "reports.climateTrendPerDecade": "Temperatuurtrend: {value} per decennium over {years} jaar",
  "reports.coldestMonthRanking": "Koudste {month} ooit gemeten",
  "reports.comfortable": "Comfortabele (45% {lessThan} Luchtvochtigheid ≤ 60%)",
  "reports.cumulativeRainfall": "Cumulatieve neerslag",
  "reports.cumulativeRainfallDescription": "Volg de totale neerslag die zich opbouwt over de geselecteerde periode.",
  "reports.dailyMaxRainfall": "Dagelijkse maximale neerslag",
  "reports.dataExport": "Exporteer data",
  "reports.dataExportXlsxFormatDescription": "Exporteer alle gegevens van uw station in Excel-formaat (*.xlsx). Zodra u op de knop klikt, ontvangt u na enkele minuten een e-mail met de verwerkte gegevens.",
  "reports.daysOfData": "{days, plural, one {# dag aan gegevens} other {# dagen aan gegevens}}",
  "reports.daysWithFrost": "Dagen met vorst",
  "reports.daysWithHeavyRain": "Dagen met zware regen (≥ {threshold})",
  "reports.daysWithoutThaw": "Dagen zonder dooi",
  "reports.daysWithStrongFrost": "Dagen met strenge vorst",
  "reports.emailSent": "Een email is naar u toegezonden",
  "reports.frostDays": "Vorstdagen",
  "reports.grasslandTemperatureSum": "Som van de grasland temperatuur",
  "reports.grasslandTemperatureSumDescription": "Als de som van {threshold} in het voorjaar wordt overschreden, is de duurzame start van de vegetatie bereikt (werkt in Europa)",
  "reports.growingDegreeDays": "Groeigraaddagen",
  "reports.highPressure": "Anticycloon (gemiddelde druk ≥ 1013 mbar)",
  "reports.iceDays": "IJsdagen",
  "reports.indoorReport": "Overzicht binnenshuis",
  "reports.keyFacts": "Belangrijkste gegevens",
  "reports.longestDrySpell": "Langste droge periode",
  "reports.longestRunOfRainyDays": "Langste reeks regenachtige dagen",
  "reports.longestRunWithoutRun": "Langste reeks droge dagen",
  "reports.longestWetSpell": "Langste natte periode",
  "reports.lowPressure": "Lage druk (gemiddelde druk {lessThan} 1013 mbar)",
  "reports.maxHumidity": "Maximale luchtvochtigheid",
  "reports.maxMetric": "Maximum {metric}",
  "reports.maxPressure": "Maximale luchtdruk",
  "reports.maxPressureMagnitude24h": "Maximale Magnitude (/24H)",
  "reports.maxTemperature": "Maximum temperatuur",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Maximale Magnitude (/24H)",
  "reports.minHumidity": "Minimale luchtvochtigheid",
  "reports.minMetric": "Minimum {metric}",
  "reports.minPressure": "Minimale luchtdruk",
  "reports.minPressureMagnitude24h": "Minimale Magnitude (/24H)",
  "reports.minTemperature": "Minimum temperatuur",
  "reports.minTempMagnitude24h": "Minimale Magnitude (/24H)",
  "reports.monthlyAverageCountdown": "{days, plural, one {Nog # dag} other {Nog # dagen}} deze maand",
  "reports.monthlyAverageCountdownDetail": "Dan verschijnen het maandgemiddelde en de ranglijst.",
  "reports.monthlyAverageRule": "Maandgemiddelden en ranglijsten verschijnen zodra een kalendermaand {days, plural, one {# geregistreerde dag} other {# geregistreerde dagen}} heeft.",
  "reports.monthlyHeatingEfficiency": "Maandelijks opwarmingsrendement",
  "reports.monthlyIndoorReport": "Maandelijks overzicht binnenshuis",
  "reports.monthlyOutdoorReport": "Maandelijks overzicht buitenshuis",
  "reports.monthlyReport": "Maandelijks overzicht",
  "reports.monthlySolarReport": "Maandelijks overzicht zonneschijn",
  "reports.monthlyWindReport": "Maandelijks windoverzicht",
  "reports.monthsOfData": "{months} maanden aan gegevens",
  "reports.numberOfDays": "Aantal dagen",
  "reports.onThisDayInHistory": "Op deze dag in de geschiedenis",
  "reports.outdoorReport": "Overzicht buitenshuis",
  "reports.overviewSection": "Overzicht",
  "reports.rainfall": "Neerslag",
  "reports.rainyDays": "Natte dagen",
  "reports.recordDailyRain": "Natste dag",
  "reports.recordHigh": "Warmterecord",
  "reports.recordLow": "Kouderecord",
  "reports.recordsAndClimatology": "Records en klimaat",
  "reports.recordsSince": "Records sinds {date}",
  "reports.recordWindGust": "Sterkste windstoot",
  "reports.relativelyWet": "Relatief nat (60% {lessThan} Luchtvochtigheid ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# rapport} other {# rapporten}}",
  "reports.sendEmail": "Verstuur email",
  "reports.summerDays": "Zomerse dagen",
  "reports.tooDry": "Te droog (Luchtvochtigheid ≤ 45%)",
  "reports.tooWet": "Te vochtig (Luchtvochtigheid {greaterThan} 80%)",
  "reports.tropicalNights": "Tropische nachten",
  "reports.unlockPremiumSubtitle": "Inbegrepen bij SmartMixin Premium",
  "reports.unlockPremiumTitle": "Ontgrendel {count, plural, one {# premiumfunctie} other {# premiumfuncties}}",
  "reports.warmestMonthRanking": "Warmste {month} ooit gemeten",
  "reports.waterBalance": "Waterbalans",
  "reports.yearsOfData": "{years} jaar aan gegevens",
  "reports.yearToDateTemperatureComparison": "Temperatuurvergelijking sinds het begin van het jaar",
  "sensors.aqiByChannel": "AQI per kanaal",
  "sensors.bgtSensors": "Zwarte bol & WBGT",
  "sensors.cameraFeed": "Camera",
  "sensors.compareAqi": "AQI vergelijken",
  "sensors.compareHumidity": "Luchtvochtigheid vergelijken",
  "sensors.compareMoisture": "Bodemvocht vergelijken",
  "sensors.comparePm25": "PM2.5 vergelijken",
  "sensors.compareTemperatures": "Temperaturen vergelijken",
  "sensors.depthByChannel": "Diepte per kanaal",
  "sensors.heatStressExtreme": "Extreme hittestress",
  "sensors.heatStressModerate": "Matige hittestress",
  "sensors.heatStressNone": "Geen hittestress",
  "sensors.heatStressStrong": "Sterke hittestress",
  "sensors.heatStressVeryStrong": "Zeer sterke hittestress",
  "sensors.humidityByChannel": "Luchtvochtigheid per kanaal",
  "sensors.indoorAirQuality": "Luchtkwaliteit binnen",
  "sensors.indoorAirQualityPm": "PM2.5 & PM10 AQI",
  "sensors.indoorClimate": "Binnenklimaat",
  "sensors.indoorCo2Levels": "CO2-niveaus",
  "sensors.indoorTemperatureAndHumidity": "Temperatuur en luchtvochtigheid",
  "sensors.last24Hours": "24 uur",
  "sensors.last30Days": "30 dagen",
  "sensors.last7Days": "7 dagen",
  "sensors.leafTemperatureByChannel": "Bladtemperatuur per kanaal",
  "sensors.leafWetnessByChannel": "Bladnatheid per kanaal",
  "sensors.lightningSensor": "Bliksem",
  "sensors.moistureByChannel": "Bodemvocht per kanaal",
  "sensors.noDataAvailable": "Geen gegevens beschikbaar",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 per kanaal",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Kanaal selecteren",
  "sensors.sensorDetailDescription": "Bekijk historische gegevens en trends voor uw sensorkanalen.",
  "sensors.sensorHistory": "Sensorgeschiedenis",
  "sensors.soilConductivityByChannel": "Geleidbaarheid per kanaal",
  "sensors.soilTemperatureByChannel": "Bodemtemperatuur per kanaal",
  "sensors.strikesToday": "Inslagen vandaag",
  "sensors.temperatureByChannel": "Temperatuur per kanaal",
  "sensors.viewChart": "Grafiek bekijken",
  "settings.about": "Over",
  "settings.aboutDescription": "Licentieovereenkomst, privacybeleid",
  "settings.account": "Account",
  "settings.accountDescription": "Profiel, wachtwoord wijzigen",
  "settings.accountIntro": "Gegevens over uw account:",
  "settings.accountOnHoldTitle": "Account gepauzeerd",
  "settings.accountSection": "Account",
  "settings.appearance": "Weergave",
  "settings.appearanceDescription": "Thema en weergaveopties",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "Arabisch",
  "settings.availableServices": "Beschikbaar",
  "settings.bulgarian": "Bulgaars",
  "settings.cannotDisconnectLastAccount": "Kan uw enige inlogmethode niet loskoppelen. Voeg eerst een andere inlogmethode toe.",
  "settings.catalan": "Catalaans",
  "settings.changeEmail": "E-mail wijzigen",
  "settings.changePassword": "Wijzig wachtwoord",
  "settings.chartGestures": "Gebaren op grafieken",
  "settings.chartGesturesDescription": "Vegen over grafieken verandert de tijdsperiode, knijpen in grafieken verandert de tijdschaal",
  "settings.choiceCount": "{count, plural, one {# beschikbaar} other {# beschikbaar}}",
  "settings.connect": "Verbinden",
  "settings.connected": "Verbonden",
  "settings.connectedAccounts": "Gekoppelde accounts",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Verbonden",
  "settings.connectedSince": "Verbonden sinds {date}",
  "settings.connectionSection": "Verbinding",
  "settings.connectionSuccess": "{provider}-account succesvol verbonden",
  "settings.contactUs": "Contact",
  "settings.contactUsDescription": "Hulp krijgen of feedback sturen",
  "settings.croatian": "Kroatisch",
  "settings.currentPassword": "Huidig wachtwoord",
  "settings.czech": "Tsjechisch",
  "settings.dailyDetailByPeriods": "Dagdetails per dagdeel",
  "settings.dailyDetailByPeriodsDescription": "Groepeer de 24 uur in nacht, ochtend, middag en avond — dezelfde indeling die de dagsamenvatting gebruikt.",
  "settings.dangerZone": "Risicozone",
  "settings.danish": "Deens",
  "settings.dark": "Donker thema",
  "settings.dataDisplay": "Gegevensweergave",
  "settings.dateAndTime": "Datum en tijd",
  "settings.disconnect": "Loskoppelen",
  "settings.disconnectConfirmation": "Weet u zeker dat u uw {provider}-account wilt loskoppelen?",
  "settings.disconnectionSuccess": "{provider}-account succesvol losgekoppeld",
  "settings.disconnectProviderDescription": "Stopt de synchronisatie. Je geschiedenis blijft bewaard.",
  "settings.donateButton": "Doneren",
  "settings.donateDescription": "SmartMixin wordt gemaakt door een klein team. Als u het nuttig vindt, kunt u de ontwikkeling steunen met een eenmalige donatie van een willekeurig bedrag. Het is een gift — het verandert uw abonnement niet en ontgrendelt geen functies.",
  "settings.donateSuccessBody": "Uw donatie helpt om SmartMixin draaiende te houden en te verbeteren. We waarderen het enorm.",
  "settings.donateSuccessTitle": "Bedankt voor uw steun!",
  "settings.donateTitle": "Steun SmartMixin",
  "settings.dragToReorder": "Sleep om te herschikken",
  "settings.dutch": "Nederlands",
  "settings.emailChange": "E-mailadres wijzigen",
  "settings.emailChangeConfirmation": "Bevestiging e-mailwijziging",
  "settings.emailChangeFailure": "De link voor e-mailwijziging is ongeldig of verlopen.",
  "settings.emailChangeSuccess": "Uw e-mailadres is succesvol gewijzigd naar {newEmail}.",
  "settings.emailChangeVerificationSent": "Er is een verificatie-e-mail verzonden naar uw nieuwe e-mailadres. Controleer uw inbox en klik op de link om de wijziging te bevestigen.",
  "settings.english": "Engels",
  "settings.forecastModelOrderEmpty": "Geen volgorde opgeslagen — we gebruiken standaard GFS.",
  "settings.forecastModelOrderFreeHint": "Premium-modellen vereisen een SmartMixin Premium-abonnement.",
  "settings.forecastModelOrderHelp": "We kiezen het eerste model in uw lijst dat elk station dekt.",
  "settings.forecastModelOrderReset": "Standaard herstellen",
  "settings.forecastModelOrderTitle": "Standaard prognosemodel",
  "settings.forecastModels": "Prognosemodellen",
  "settings.forecastModelsDescription": "Sorteren op voorkeur",
  "settings.french": "Frans",
  "settings.german": "Duits",
  "settings.gestures": "Gebaren",
  "settings.greek": "Grieks",
  "settings.helpCenter": "Helpcentrum",
  "settings.helpCenterDescription": "Veelgestelde vragen en handleidingen",
  "settings.hungarian": "Hongaars",
  "settings.integrationsSection": "Integraties",
  "settings.italian": "Italiaans",
  "settings.japanese": "Japans",
  "settings.korean": "Koreaans",
  "settings.language": "Taal",
  "settings.languageDescription": "Voorkeurstaal",
  "settings.light": "Licht thema",
  "settings.measurementUnits": "Meeteenheden",
  "settings.modelOrderSection": "Modelvolgorde",
  "settings.newEmailAddress": "Nieuw e-mailadres",
  "settings.newPassword": "Nieuw wachtwoord",
  "settings.newPasswordAgain": "Nieuw wachtwoord nogmaals",
  "settings.norwegian": "Noors",
  "settings.notConnected": "Niet verbonden",
  "settings.notificationsSection": "Meldingen",
  "settings.oldPassword": "Oud wachtwoord",
  "settings.ongoingNotificationEnabled": "Permanente melding inschakelen",
  "settings.ongoingNotificationMetrics": "Weergegeven metingen",
  "settings.ongoingNotificationPermissionRequired": "Meldingstoestemming is vereist",
  "settings.ongoingNotificationPreviewHint": "Voorbeeld — schakel de widget in om hem te tonen",
  "settings.ongoingNotificationStation": "Weerstation",
  "settings.ongoingNotificationStatusBar": "Statusbalk",
  "settings.passwordChange": "Wachtwoord wijzigen",
  "settings.passwordChangeDescription": "Houd je account veilig",
  "settings.polish": "Pools",
  "settings.portuguese": "Portugees",
  "settings.preferencesSection": "Voorkeuren",
  "settings.premium": "Premium",
  "settings.premiumActive": "Actief",
  "settings.premiumAnnualThenPrice": "Daarna 9,99 €/jaar",
  "settings.premiumAnnualTrialInfo": "Begin met een gratis proefperiode van {days} dagen",
  "settings.premiumCurrentPlan": "Huidig abonnement",
  "settings.premiumDescription": "Ontgrendel premiumfuncties",
  "settings.premiumDownloadApp": "Download de app om te abonneren:",
  "settings.premiumExpiresOn": "Verlenging op {date}",
  "settings.premiumFreePlan": "Gratis",
  "settings.premiumInactive": "Niet geabonneerd",
  "settings.premiumManageWebSubscription": "Beheer uw abonnement, werk de betaalmethode bij of annuleer.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Jaarlijks — 9,99 €/jaar",
  "settings.premiumSubscribedOn": "Geabonneerd op {platform}",
  "settings.premiumSubscribeMonthly": "Maandelijks — 1,99 €/maand",
  "settings.premiumSubscribeOnWeb": "Abonneer nu om alle premiumfuncties te ontgrendelen.",
  "settings.premiumSubscriptionSuccess": "Uw abonnement is geactiveerd! Geniet van alle premiumfuncties.",
  "settings.premiumSubscriptionSuccessTitle": "Welkom bij Premium!",
  "settings.premiumWebappNotice": "Abonnementen kunnen alleen worden aangeschaft via de SmartMixin mobiele app op iOS of Android.",
  "settings.privacyPolicy": "Privacybeleid",
  "settings.profile": "Profiel",
  "settings.russian": "Russisch",
  "settings.serbian": "Servisch",
  "settings.settings": "Instellingen",
  "settings.signedInAs": "Ingelogd als",
  "settings.slovak": "Slovaaks",
  "settings.smallDecimals": "Kleine decimalen",
  "settings.smallDecimalsDescription": "Decimale cijfers in een kleiner formaat weergeven",
  "settings.socialConnectionsIntro": "Koppel uw sociale accounts voor snelle aanmelding. U kunt op elk moment accounts verbinden of loskoppelen.",
  "settings.spanish": "Spaans",
  "settings.statusBarWidget": "Statusbalk-widget",
  "settings.statusBarWidgetDescription": "Altijd zichtbare weerdata",
  "settings.subscriptionSection": "Abonnement",
  "settings.supportSection": "Ondersteuning",
  "settings.swedish": "Zweeds",
  "settings.systemTheme": "Systeem thema",
  "settings.termsOfService": "Gebruiksvoorwaarden",
  "settings.turkish": "Turks",
  "settings.ukrainian": "Oekraïens",
  "settings.units": "Eenheden",
  "settings.unitsDescription": "Maateenheden weergegeven in de applicatie",
  "settings.update": "Actualiseer",
  "settings.updateYourProfile": "Actualiseer uw profiel",
  "settings.updateYourProfileDescription": "Naam en weergavevoorkeuren",
  "settings.weatherServices": "Weerdiensten",
  "settings.weatherServicesConnected": "{count, plural, =0 {Geen diensten verbonden} one {# dienst verbonden} other {# diensten verbonden}}",
  "settings.weatherServicesDescription": "Verbind Netatmo, Davis, Weatherflow en meer",
  "settings.windDirectionConvention": "Windrichtingpijl",
  "settings.windDirectionConventionDescription": "Kies hoe windrichtingpijlen worden weergegeven",
  "settings.windDirectionMeteorological": "Oorsprongsrichting",
  "settings.windDirectionMeteorologicalDescription": "Pijl wijst waar de wind vandaan komt (meteorologische conventie)",
  "settings.windDirectionOceanographic": "Stromingsrichting",
  "settings.windDirectionOceanographicDescription": "Pijl wijst waar de wind naartoe waait (oceanografische conventie)",
  "units.absolutePressure": "Absolute druk",
  "units.airDensity": "Luchtdichtheid",
  "units.airGap": "Luchtspleet",
  "units.apparentTemperature": "Gevoelstemperatuur",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Gem.",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Zwarte bol temp.",
  "units.boilerOn": "Verwarming AAN",
  "units.co2": "CO2",
  "units.conductivity": "Geleidbaarheid",
  "units.coolingDegreeDays": "Verkoelende graaddagen",
  "units.dailyHeatingDuration": "Dagelijkse opwarmingsduur",
  "units.dailyPrecipitation": "Dagelijkse neerslag",
  "units.dailyRain": "Dagelijkse neerslag",
  "units.degreeDay": "Graaddag",
  "units.degreeDayShort": "DD",
  "units.depth": "Diepte",
  "units.depthSensors": "Dieptesensoren",
  "units.dewPoint": "Dauwpunt",
  "units.distance": "Afstand",
  "units.downTrend": "neer",
  "units.E": "O",
  "units.E_long": "Oost",
  "units.ENE": "ONO",
  "units.ENE_long": "Oost-Noordoost",
  "units.ESE": "OZO",
  "units.ESE_long": "Oost-Zuidoost",
  "units.ET": "Verdamping",
  "units.ETshort": "ET",
  "units.feelLike": "Gevoel",
  "units.feelsLike": "Gevoel",
  "units.footMile": "Voet, mijl",
  "units.frostPoint": "Vorstpunt",
  "units.gust": "Windstoot",
  "units.heatIndex": "Hitte-index",
  "units.heatingDegreeDays": "Opwarming graaddagen",
  "units.heatingPower": "Opwarmingskracht",
  "units.humidex": "Humidex",
  "units.humidity": "Luchtvochtigheid",
  "units.inch": "Inch",
  "units.inchOfMercury": "in Hg",
  "units.kilometerPerHour": "Km/u",
  "units.knot": "Knopen",
  "units.last12Hours": "Laatste 12 uur",
  "units.last24Hours": "Laatste 24 uur",
  "units.last3Hours": "Laatste 3 uur",
  "units.last6Hours": "Laatste 6 uur",
  "units.lastHour": "Laatste uur",
  "units.lastLightningImpact": "Laatste inslag",
  "units.lastMeasure": "Laatste meting",
  "units.leafSensors": "Bladsensor",
  "units.leafWetness": "Bladvochtigheid",
  "units.lightningDistance": "Afstand",
  "units.lightningStrikeCount": "Aantal bliksemontladingen",
  "units.lightningStrikeDistance": "Afstand bliksemontladingen",
  "units.max": "Max.",
  "units.max_gust": "Max. windstoot",
  "units.max_wind": "Max. wind",
  "units.meterKilometer": "Meter, kilometer",
  "units.meterPerSecond": "Meter per seconde",
  "units.milePerHour": "Mijl per uur",
  "units.millibar": "Millibar",
  "units.millimeter": "Millimeter",
  "units.millimeterOfMercury": "Millimeter kwik",
  "units.min": "Min.",
  "units.N": "N",
  "units.N_long": "Noord",
  "units.NE": "NO",
  "units.NE_long": "Noordoost",
  "units.NNE": "NNO",
  "units.NNE_long": "Noord-Noordoost",
  "units.NNW": "NNW",
  "units.NNW_long": "Noord-Noordwest",
  "units.noise": "Geluid",
  "units.normalizedHeatingCoefficient": "Genormaliseerde opwarmingscoëfficiënt",
  "units.NW": "NW",
  "units.NW_long": "Noordwest",
  "units.O3": "Ozon",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2.5",
  "units.precipitation": "Neerslag",
  "units.pressure": "Luchtdruk",
  "units.rain": "Neerslag",
  "units.rainRate": "Regenintensiteit",
  "units.referenceTemperature": "Referentietemperatuur",
  "units.relativePressure": "Relatieve luchtdruk",
  "units.S": "Z",
  "units.S_long": "Zuid",
  "units.SE": "ZO",
  "units.SE_long": "Zuidoost",
  "units.setPoint": "Setpunt",
  "units.snow": "Sneeuw",
  "units.snowfall": "Sneeuwval",
  "units.soilMoisture": "Vocht",
  "units.soilSensors": "Bodemsensoren",
  "units.solarEnergy": "Zonne-energie",
  "units.solarRadiation": "Zonnestraling",
  "units.speed": "Snelheid",
  "units.SSE": "ZZO",
  "units.SSE_long": "Zuid-Zuidoost",
  "units.SSW": "ZZW",
  "units.SSW_long": "Zuid-Zuidwest",
  "units.stableTrend": "Stabiel",
  "units.sum": "Som",
  "units.SW": "ZW",
  "units.SW_long": "Zuidwest",
  "units.temperature": "Temperatuur",
  "units.temperatureAndHumiditySensors": "Temperatuur & Luchtvochtigheidsensoren",
  "units.temperatureSensors": "Temperatuur & Luchtvochtigheidsensoren",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Vandaag",
  "units.upTrend": "Opgang",
  "units.uv": "UV",
  "units.visibility": "Zicht",
  "units.W": "W",
  "units.W_long": "West",
  "units.wetBulbGlobeTemperature": "WBG Temperatuur",
  "units.wetBulbTemperature": "WB Temperatuur",
  "units.wind": "Wind",
  "units.windChill": "Gevoelstemperatuur",
  "units.windDirection": "Windrichting",
  "units.windRun": "Windloop",
  "units.windRunDescription": "De windloop is de totale afstand van de afgelegde wind over een bepaald tijdsinterval",
  "units.WNW": "WNW",
  "units.WNW_long": "West-Noordwest",
  "units.WSW": "WZW",
  "units.WSW_long": "West-Zuidwest"
}
